import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  user: null,
  response: null,
  loading: false,
  error: null,
  callTimes: 0,
  message: '',
  data: '',
}

export const guessingnumberSlice = createSlice({
  name: 'guesingnumberSliceName',
  initialState,
  reducers: {
    addNumber: () => {


    },
    getNumber: () => {
    },
    getOneNumber: () => {

    },

    successNumber: (state, action) => {
      console.log(state.data , action.payload.data)
      state.data = action.payload
  },
    removeNumber: () => {
    },
    updateNumber: () => {
    },
    emptyCart: (state, action) => {
      state.value += action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const { addNumber, removeNumber, updateNumber, getNumber, successNumber, getOneNumber } = guessingnumberSlice.actions

export default guessingnumberSlice.reducer